// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__ui-table-meta-SiVETU {
  align-items: center;
  width: 100%;
  height: 40px;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__ui-table-meta-SiVETU .\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__table-name-ARFJ08 {
  flex: 1;
  margin-left: 16px;
}

.\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__ui-table-meta-SiVETU .\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-avatar-UYxGlN {
  border-radius: 6px;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  margin-right: 16px;
}

.\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__ui-table-meta-SiVETU .\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-right-QIkpIY {
  width: 100%;
}

.\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__ui-table-meta-SiVETU .\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-right-width-g3VLg2 {
  width: calc(100% - 32px);
}

.\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__ui-table-meta-SiVETU .\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-name-zw8r2v {
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--light-usage-text-color-text-0, #1c1d23);
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  overflow: hidden;
}

.\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__ui-table-meta-SiVETU .\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-description-uBVcJU {
  word-break: break-word;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  color: var(--light-usage-text-color-text-1, rgba(28, 29, 35, .8));
  -webkit-box-orient: vertical;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  display: -webkit-box;
  overflow: hidden;
}

.\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__ui-table-meta-SiVETU .\\------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-suffix-bLV01s {
  margin-top: 2px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-table-meta": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__ui-table-meta-SiVETU`,
	"uiTableMeta": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__ui-table-meta-SiVETU`,
	"table-name": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__table-name-ARFJ08`,
	"tableName": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__table-name-ARFJ08`,
	"meta-avatar": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-avatar-UYxGlN`,
	"metaAvatar": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-avatar-UYxGlN`,
	"meta-right": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-right-QIkpIY`,
	"metaRight": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-right-QIkpIY`,
	"meta-right-width": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-right-width-g3VLg2`,
	"metaRightWidth": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-right-width-g3VLg2`,
	"meta-name": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-name-zw8r2v`,
	"metaName": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-name-zw8r2v`,
	"meta-description": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-description-uBVcJU`,
	"metaDescription": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-description-uBVcJU`,
	"meta-suffix": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-suffix-bLV01s`,
	"metaSuffix": `------packages-components-bot-semi-src-components-ui-table-meta-index-module__meta-suffix-bLV01s`
};
export default ___CSS_LOADER_EXPORT___;
